import React, { useState } from 'react'

// Category mapping — exact keys from your existing plan.coverage structure
const categories = {
  Preventive: ['exams', 'bitewing_xray', 'Panoramic_xray', 'FMX_xray', 'fluoride', 'sealants', 'prophy'],
  Basic: ['fillings', 'endo', 'extractions', 'srp', 'periodontal', 'anesthesia', 'perio_maintenance'],
  Major: ['crowns', 'bridges', 'dentures', 'implants', 'core_buildup', 'inlays_onlays'],
  Surgery: ['oral_surgery', 'osseous_surgery'],
  Orthodontic: ['orthodontic']
}

const getCardColor = (value) => {
  const val = (value || '').toString().replace('%', '').trim()
  if (val === '100') return '#dcfce7' // green
  if (val === '0' || val === '') return '#fee2e2' // red
  return '#f3f4f6' // gray
}

const AccordionSection = ({ category, procedures, plan, isOpen, toggleOpen }) => {
  const validItems = procedures.filter((proc) => plan.coverage?.[proc])
  if (validItems.length === 0) return null

  return (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '1rem', background: '#f9fafb' }}>
      <div
        onClick={toggleOpen}
        style={{
          padding: '0.75rem 1rem',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '1rem',
          background: '#f1f5f9',
          userSelect: 'none',
        }}
      >
        {category} {isOpen ? '▾' : '▸'}
      </div>

      {isOpen && (
        <div style={{ padding: '1rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
            {validItems.map((proc) => {
              const { coverage_percent, notes } = plan.coverage[proc] || {}
              const bg = getCardColor(coverage_percent)

              return (
                <div key={proc} style={{ background: bg, padding: '0.75rem', borderRadius: '6px', border: '1px solid #d1d5db' }}>
                  <strong style={{ textTransform: 'capitalize' }}>{proc.replace(/_/g, ' ')}</strong>
                  <p style={{ margin: '0.25rem 0' }}>
                    <strong>Coverage:</strong> {coverage_percent || '—'}
                  </p>
                  <p style={{ margin: 0 }}>
                    <strong>Notes:</strong> {notes || '—'}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

function CoverageBreakdownTab({ plan }) {
  const categoryKeys = Object.keys(categories)
  const [openStates, setOpenStates] = useState(() =>
    categoryKeys.map((_, i) => i === 0) // First section open by default
  )

  const toggleSection = (index) => {
    const newStates = [...openStates]
    newStates[index] = !newStates[index]
    setOpenStates(newStates)
  }

  const toggleAll = () => {
    const areAllOpen = openStates.every(Boolean)
    setOpenStates(openStates.map(() => !areAllOpen))
  }

  if (!plan?.coverage) return <p>No coverage breakdown available.</p>

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <button
          onClick={toggleAll}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#1d4ed8',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.9rem',
          }}
        >
          {openStates.every(Boolean) ? 'Collapse All' : 'Expand All'}
        </button>
      </div>

      {categoryKeys.map((category, index) => (
        <AccordionSection
          key={category}
          category={category}
          procedures={categories[category]}
          plan={plan}
          isOpen={openStates[index]}
          toggleOpen={() => toggleSection(index)}
        />
      ))}
    </div>
  )
}

export default CoverageBreakdownTab
